<template>
    <div>
        <Transition
            enter-active-class="transition ease-in-out duration-500 transform"
            enter-from-class="-translate-y-[-100%]"
            enter-to-class="translate-y-0"
            leave-active-class="transition ease-in-out duration-500 transform"
            leave-from-class="translate-y-0"
            leave-to-class="-translate-y-[-100%]"
        >
            <div v-if="showBanner" class="fixed bottom-0 h-20 w-full flex items-center z-[999]">
                <div
                    class="relative w-full h-full bg-gray-900/80 backdrop-blur-lg flex items-center text-white overflow-hidden"
                >
                    <div class="container flex items-center md:justify-between justify-center z-20">
                        <p class="text-gray-100 md:block hidden text-title-sm font-bold">
                            {{ $t("landingComponents_uploader_bottom_text") }}
                        </p>
                        <AppButton
                            :id="stickyUploadBtnId"
                            prepend-icon="tabler:upload"
                            :block="useDevice().isMobile"
                            color="white"
                            @click="scrollToUploader"
                        >
                            {{ $t("landingComponents_uploader_bottom_button") }}
                        </AppButton>
                    </div>

                    <div
                        :class="circleItem"
                        :key="`abstract-circle-${idx}`"
                        v-for="(circleItem, idx) in circleItems"
                        class="absolute rounded-full z-10 w-[253px] h-[264px] blur-[200px]"
                    ></div>
                </div>
            </div>
        </Transition>
    </div>
</template>

<script setup lang="ts">
const { y } = useWindowScroll();

const showBanner = ref(false);

const targetElement = ref<HTMLElement | null>(null);

const targetIsVisible = useElementVisibility(targetElement);

onMounted(() => {
    targetElement.value = document.getElementById(`${serviceNameResolver()}-parent-section`);
});

interface IProps {
    serviceSlug: "vs" | "ir" | "ie" | "dd";
}

const props = defineProps<IProps>();

watchEffect(() => {
    if (y.value >= 500 && !targetIsVisible.value) {
        showBanner.value = true;
    } else {
        showBanner.value = false;
    }
});

const circleItems = [
    "bg-brand-500 left-[219px] -top-[66px]",
    "bg-aqua-500 left-[616px] top-[74px]",
    "bg-blue-400 right-[200px] -top-[221px]",
    "bg-red-400 right-[150px] -top-[33px]",
];

function serviceNameResolver() {
    switch (props.serviceSlug) {
        case "vs":
            return "service-ai-virtual-staging";
        case "ie":
            return "service-image-enhancement";
        case "ir":
            return "service-item-removal";
        case "dd":
            return "service-day-to-dusk";
        default:
            return "";
    }
}

function scrollToUploader() {
    targetElement.value?.scrollIntoView({ block: "center" });
}

const stickyUploadBtnId = computed(() => {
    let servicesListID = {
        vs: "virtualstaging-sticky-upload",
        ie: "imageenhancement-sticky-upload",
        ir: "itemremoval-sticky-upload",
        dd: "daytodusk-sticky-upload",
    };
    return servicesListID[props.serviceSlug] || "";
});
</script>
